export default {
    test: "测试  11",
    lng: `简体中文`,
};
